import { forwardRef, memo, useEffect, useRef } from "react"
import { gsap } from "gsap"

const TrucoGameWinPopUp = forwardRef(({ gameWinnerDetails, onClose, showRestartGameOptions, quitGameHandler = () => { } }, ref) => {

    const containerRef = useRef()

    useEffect(() => {
        if (!containerRef.current) return

        // ENTER animation
        gsap.fromTo(
            containerRef.current,
            { scale: 0, opacity: 0 },
            { scale: 1, opacity: 1, duration: 0.5, ease: "back.out(1.7)" }
        )

        // AUTO CLOSE after 5s
        // const timer = setTimeout(() => {
        //     gsap.to(containerRef.current, {
        //         scale: 0,
        //         opacity: 0,
        //         duration: 0.5,
        //         ease: "power2.in",
        //         onComplete: onClose
        //     })
        // }, 5000)

        // return () => clearTimeout(timer)

    }, [onClose])

    return (
        <div className='truco-win-info-container'>
            <div ref={containerRef} className='truco-win-info-outer-box'>
                <div className='truco-win-info-inner-box'>

                    <h1 className="truco-win-info-title">{gameWinnerDetails?.amIWinner ? "WINNER" : "GAME OVER"}</h1>

                    <div className='truco-win-info-details'>
                        <span className='truco-winner-info-player-details'>
                            {gameWinnerDetails?.amIWinner ? "Congratulations !!!" : "Better Luck Next Time !!!"}
                            {/* Your Win points:
                            <span>{gameWinnerDetails?.playerEnvidoPoints || 0}</span> */}
                        </span>
                        <span className='truco-winner-info-player-details'>
                            {gameWinnerDetails?.amIWinner ? "You Won The Game." : ""}
                            {/* Your Win points:
                            <span>{gameWinnerDetails?.playerEnvidoPoints || 0}</span> */}
                        </span>

                        {/* <span className='truco-winner-info-player-details'>
                            Opponent's Win points:
                            <span>{gameWinnerDetails?.opponentEnvidoPoints || 0}</span>
                        </span> */}

                        <span className='truco-game-winner-details'>
                            Winner:
                            <span>{gameWinnerDetails?.playerId || "N/A"}</span>
                        </span>
                    </div>
                    <div className="truco-game-win-popup-btn-grp">
                        {Boolean(showRestartGameOptions) &&
                            <button className="truco-game-win-popup-btn" onClick={() => { quitGameHandler("GAME_RESTART_REQUEST") }}>Start Again</button>
                        }
                        <button className="truco-game-win-popup-btn" onClick={() => { quitGameHandler("QUIT_GAME") }}>Leave Table</button>
                    </div>

                </div>
            </div>
        </div>
    )
})

export default memo(TrucoGameWinPopUp)